export default __webpack_public_path__ + "static/media/matari.f740646b.jpg";